import createCustomPropType from './createCustomPropType';

/**
 * Validator for a prop that can be either a node or undefined
 * The node validation is taken from:
 * https://stackoverflow.com/questions/384286/javascript-isdom-how-do-you-check-if-a-javascript-object-is-a-dom-object
 *
 * @param {object} props
 * @param {string} propName
 * @param {string} componentName
 *
 * @return {null|Error}
 */
const isValidDOMNodeOrUndefined = (props, propName, componentName) => {
  const val = props[propName];
  const isNode =
    typeof Node === 'object'
      ? val instanceof Node
      : val &&
        typeof val === 'object' &&
        typeof val.nodeType === 'number' &&
        typeof val.nodeName === 'string';

  if (!isNode && typeof val !== 'undefined') {
    throw new Error(
      `Invalid prop ${propName} supplied to ${componentName}.
              Validation failed. Prop must be of type node or undefined.`
    );
  }
};

const validDOMNodeOrUndefined = createCustomPropType(isValidDOMNodeOrUndefined);

export default validDOMNodeOrUndefined;
